import type React from 'react';
import { formatJst } from '../lib/format.ts';
import type { IndustrySignal } from '../types/industry.ts';

type Props = {
  signals: readonly IndustrySignal[];
};

/**
 * 縦断モードの時系列表示（簡易テーブル）。
 * Phase 2 でグラフ化（Chart.js or recharts）を検討。
 */
export const SignalTimeline = ({ signals }: Props): React.JSX.Element => {
  if (signals.length === 0) {
    return <p style={mutedStyle}>シグナルがまだありません。</p>;
  }
  return (
    <table style={tableStyle}>
      <thead>
        <tr>
          <th style={thStyle}>取得時刻</th>
          <th style={thStyle}>ソース</th>
          <th style={thStyle}>メトリクス</th>
          <th style={thRightStyle}>値</th>
        </tr>
      </thead>
      <tbody>
        {signals.map((s, idx) => (
          <tr key={`${s.captured_at}-${s.metric}-${idx}`}>
            <td style={tdStyle}>{formatJst(s.captured_at)}</td>
            <td style={tdStyle}>{s.source_name}</td>
            <td style={tdStyle}>{s.metric}</td>
            <td style={tdRightStyle}>{s.value ?? '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const tableStyle: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 13,
};
const thStyle: React.CSSProperties = {
  textAlign: 'left',
  padding: '8px 12px',
  borderBottom: '1px solid #ddd',
  background: '#f7f7f7',
};
const thRightStyle: React.CSSProperties = { ...thStyle, textAlign: 'right' };
const tdStyle: React.CSSProperties = {
  padding: '6px 12px',
  borderBottom: '1px solid #f0f0f0',
};
const tdRightStyle: React.CSSProperties = { ...tdStyle, textAlign: 'right' };
const mutedStyle: React.CSSProperties = { color: '#888', padding: 12, fontSize: 13 };
